<script>
import api from './../apiBridge'
import router from './../router';

export default {
  methods: {
    logout() {
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.logout) {
        window.webkit.messageHandlers.logout.postMessage(null);
      } else {
        api.storeSelected = false;
        api.storeNumber = null;
        api.setStore(0);

        router.push('/login');

        // reload page shortly after to get latest version
        setTimeout(() => {
          this.reload();
        },200)
      }
    },

    gotoBack() {
      router.back();
    },

    reload() {
      location.reload(true);
    }    
  },

  mounted: function(){
    console.log('Info page');

    document.body.style.backgroundColor = "#000";

    if (window.config) {
      this.version = window.config.version;
      this.ip = window.config.ip;
    }
  },

  data() {
    return {
        storeNumber: api.storeNumber,
        version: '??',
        ip: '??',
        build: process.env.build,
        error: ''
    }
  }
}
</script>

<template>
  <div class="row center-block" @keyup.enter="loginWithStoreNumber()" >
    <h4 v-if="error" style="color: yellow; margin: 20px;">
      ERR: {{error}}
    </h4>
    <br><br><br>
    <div style="color:white; text-align: center;">
      <div style="font-size: 14pt;">{{$t('native_version')}}: <b>{{version}}</b></div>
      <div style="font-size: 14pt;">{{$t('build_version')}}: <b>{{build}}</b></div>
      <div style="font-size: 14pt;">{{$t('store_number')}}: <b>{{storeNumber || '??'}}</b></div>
      <div style="font-size: 14pt;">{{$t('ip_address')}}: <b>{{ip}}</b></div>
    </div>
    <br clear="all" />
    <div>
      <div class="center-block" style="margin-top: 2em; width: 30%">
          <button 
           @click="gotoBack()"
           class="btn btn-lg btn-block btn-success" 
           style="height: 60px; padding-top: 14px; font-weight: bold;"
          ><i class="fas fa-arrow-left pull-left"
           style="margin: 2px -20px 0px 0px;"
          ></i>{{$t('back')}}</button>
      </div>  
      <br clear="all" />
      <div class="center-block" style="margin-top: 1em; width: 30%">
          <button 
           @click="logout()"
           class="btn btn-block btn-lg btn-danger"
           style="height: 60px; padding-top: 14px; font-weight: bold;"
          ><i class="fas fa-sign-out-alt pull-left"
           style="margin: 2px -20px 0px 0px;"
          ></i>{{$t('logout')}}</button>
      </div>
      <!--
      <div class="center-block" style="margin-top: 1em; width: 30%">
          <button 
           @click="reload()"
           class="btn btn-block btn-lg btn-default"
           style="height: 60px; padding-top: 14px; font-weight: bold;"
          ><i class="fas fa-redo pull-left"
           style="margin: 2px -20px 0px 0px;"
          ></i>{{$t('reload')}}</button>
      </div>
      -->
    </div>
  </div>
</template>


// WEBPACK FOOTER //
// InfoDisplay.vue?078d3a62